import React from "react";

import { getCurrentPlatformTermsAndConditions } from "services";

import { getIubendaPolicyId, getLanguageFromLocalStorage, openFileInNewTab, useTranslation } from "utils";

import { Anchor, Typography } from "components";

type SignupTermsTextProps = {
  // The checkbox needs a first-person pledge, the acquisition flow a passive one. Only the lead-in differs.
  leadIn: string;
};

export const SignupTermsText = ({ leadIn }: SignupTermsTextProps) => {
  const { t } = useTranslation("signinup");
  const language = getLanguageFromLocalStorage();

  const handlePlatformTermsClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    const data = await getCurrentPlatformTermsAndConditions();
    openFileInNewTab(data);
  };

  return (
    <>
      <Typography variant="paragraph-m">{`${leadIn} `}</Typography>
      <Anchor onClick={(e: React.MouseEvent) => handlePlatformTermsClick(e)}>{t("terms.terms")}</Anchor>
      <Typography variant="paragraph-m">{` ${t("terms.and")} `}</Typography>
      <Anchor href={`https://www.iubenda.com/privacy-policy/${getIubendaPolicyId(language)}`} target="_blank">
        {t("terms.privacy")}
      </Anchor>
      <Typography variant="paragraph-m">{"."}</Typography>
    </>
  );
};
